import React, { useState, useEffect } from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from 'react-icons/fa';
import '../styles/pages/Team.scss';
import { cmsAPI, getImageUrl } from '../utils/api';

function Team() {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    cmsAPI.getTeam()
      .then(res => {
        if (res.data.success) {
          setTeamMembers(res.data.data);
        }
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching team:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="team-page">
      {/* Hero Section */}
      <section className="team-hero">
        <h1>Meet Our Full Team</h1>
        <p>The talented professionals driving our success</p>
      </section>

      {/* Team Grid Section */}
      <section className="team-section">
        <div className="team-container">
          {loading ? (
            <p style={{ textAlign: 'center', padding: '50px 0' }}>Loading team members...</p>
          ) : (
            <div className="team-grid">
              {teamMembers.map((member) => (
                <div key={member.id} className="team-circle-card">
                  {/* Decorative shapes */}
                  <div className="team-deco-shapes">
                    <div className="deco-top-right">
                      <span className="deco-pill-1"></span>
                      <span className="deco-pill-2"></span>
                    </div>
                    <div className="deco-bottom-left">
                      <span className="deco-circle"></span>
                      <span className="deco-curve"></span>
                    </div>
                  </div>

                  {/* Circular image */}
                  <div className="team-circle-img">
                    <img 
                      src={getImageUrl(member.image)} 
                      alt={member.name} 
                    />
                  </div>

                  {/* Info */}
                  <div className="team-circle-info">
                    <h3>{member.name}</h3>
                    <span className="team-role">{member.role}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default Team;
